import {useCallback, useMemo} from 'react';

import {useFeatureFlags} from '~utils/featureFlags';
import {InspectionType, Model} from '~redux/types/models';

export function useIsModelVisible(): (model: Model) => boolean {
  const {toggleEnableMeasuringApp} = useFeatureFlags();
  return useCallback(
    (model: Model) => toggleEnableMeasuringApp === true || model.inspectionType !== InspectionType.measurement,
    [toggleEnableMeasuringApp],
  );
}

export function useVisibleModels(models: Model[] | undefined): Model[] | undefined {
  const isModelVisible = useIsModelVisible();
  return useMemo(() => models?.filter(isModelVisible), [models, isModelVisible]);
}
